import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLocalPolice = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.5 11V5.97481L12 2.64148L19.5 5.97481V11C19.5 15.7883 16.256 20.2162 12 21.4479C7.74395 20.2162 4.5 15.7883 4.5 11ZM3 5L12 1L21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5ZM15.09 16L12 14.2332L8.91 16L9.73 12.67L7 10.4295L10.595 10.1405L12 7L13.405 10.1405L17 10.4295L14.27 12.67L15.09 16Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgLocalPolice);
export default ForwardRef;
